import Vue from 'vue'
import VueRouter from 'vue-router'
import UnexApp from './UnexApp.vue'
import App from './application.js'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: UnexApp,

        beforeEnter: async (to, from, next) => {
            // Redirect to query
            next('/query');
        }
    },
    {
        path: '/mustLogin',
        name: 'mustLogin',
        component: UnexApp,

        beforeEnter: async (to, from, next) => {
            App.root_activated_view = 'must_login';
            next();
        }
    },
    {
        path: '/query',
        name: 'query',
        component: UnexApp,

        beforeEnter: async (to, from, next) => {
            if (window.Unex.Authentication.isLogged == false) {
                App.auth_returl_url = to.path
                next('/mustLogin')
                return;
            }

            App.bus.$emit('is_back_to_filter_view');
            App.root_activated_view = 'query_filters';
            next();
        }
    },
    {
        path: '/solutions',
        name: 'solutions',
        component: UnexApp,

        beforeEnter: async (to, from, next) => {
            if (window.Unex.Authentication.isLogged == false) {
                App.auth_returl_url = to.path
                next('/mustLogin')
                return;
            }

            App.root_activated_view = 'application_solutions';
            next();
        }
    },
    {
        path: '/solutions/:idsolution',
        name: 'solution',
        component: UnexApp,

        beforeEnter: async (to, from, next) => {
            if (window.Unex.Authentication.isLogged == false) {
                App.auth_returl_url = to.path
                next('/mustLogin')
                return;
            }

            App.root_activated_view = 'single_application_solution';
            // App.id_selected_obra = to.params.id
            App.id_selected_solution = to.params.idsolution
            next();
        }
    },
]

// eslint-disable-next-line no-new
const router = new VueRouter({
    routes
})

export default router